<template>
    <div>
        <div class="perLibary app-body">
            <page-header></page-header>
            <scree-compent :type="currentLibary"></scree-compent>
            <div class="bottom">
                <div class="nav xy-between">
                    <div class="nav-tive jf">
                        <div class="topic xy-center" :class="{'avtie' :currentSatus === 'topic' }" @click="switchTopic">
                            <div class="yx-center">
                                <div class="cursor">试题</div>
                                <div class="throw" v-if="currentSatus === 'topic'"></div>
                            </div>
                        </div>
                        <div class="paper xy-center" :class="{'avtie' :currentSatus === 'paper' }" @click="switchPaper">
                            <div class="yx-center">
                                <div class="cursor">试卷</div>
                                <div class="throw" v-if="currentSatus === 'paper'"></div>
                            </div>
                        </div>
                    </div>
                    <div class="search">
                        <el-input placeholder="请输入关键字检索" v-model="searchKey">
                            <template slot="append">
                                <i class="el-icon-search"></i>
                                <span class="cursor">搜索</span>
                            </template>
                        </el-input>
                    </div>
                </div>
                <!-- 列表 -->
                <div>
                    <div v-if="topiclIstShow" class="topicList">
                        <item-list :list="topicList" v-if="topicList.length && !topicLoading"
                                   @saveLocalstory="saveStatu" type="topic">
                        </item-list>
                        <div v-else-if="!topicList.length && !topicLoading"
                             class="loadingContent xy-center font-size18 c-969799">暂无数据~
                        </div>
                        <div v-else v-loading="topicLoading" class="loadingContent"></div>
                    </div>

                    <div v-else class="PaperList">
                        <item-list :list="PaperList" v-if="PaperList.length && !paperLoading" type="paper"></item-list>
                        <div v-else-if="!PaperList.length && !paperLoading"
                             class="loadingContent xy-center font-size18 c-969799">暂无数据~
                        </div>
                        <div v-else v-loading="paperLoading" class="loadingContent"></div>
                    </div>
                </div>

            </div>

            <div class="paging xy-center">
                <el-pagination background
                               @size-change="getSizeChange" @current-change="getCurrentChange"
                               :current-page.sync="pageno" :page-size="pagesize"
                               layout="total, sizes, prev, pager, next, jumper"
                               :total="total">
                </el-pagination>
            </div>

            <div class="selectType yx-center" @click="goPublicTopicLibary">
                <img src="../../assets/img/tiku.png" alt="">
                <div class="c-fff">公共题库</div>
            </div>
            <el-backtop :bottom="300">
                <div class="test xy-center ">
                    <i class=" el-icon-arrow-up font-size50"></i>
                </div>
            </el-backtop>

        </div>
        <bottom-ground></bottom-ground>

    </div>
</template>

<script>
import {
    GetQuestionInfo
} from "@/api/questionPaper"
import {
    GetMedicalPaper
} from "@/api/course"
import PageHeader from "@/components/header";
import ScreeCompent from "@/components/screening";
import ItemList from "@/components/perLibary/list";
import PaperList from "@/components/perLibary/paperList";
import BottomGround from "@/components/bottomnav";
import { replaceImgTag } from "@/utils/regexp";

export default {
    components: {
        PageHeader,
        ScreeCompent,
        ItemList,
        BottomGround
    },
    data() {
        return {
            switchti: true,
            currentLibary: "per",
            currentSatus: "topic",
            searchKey: "",
            topicList: [],
            PaperList: [],
            resourceNum: 0,
            topicLoading: true,
            paperLoading: true,
            topiclIstShow: true,
            passClassId: "", // 子传父的id
            timer: "",
            pageno: 1,
            pagesize: 10,
            total: 0,
            type: ""
        }
    },
    computed: {},
    watch: {
        passClassId(newVal, oldval) {
            if (newVal !== oldval) {
                this.searchKey = ""
            }
            if (this.currentSatus === "topic") {
                this.pageno = 1
                // 表示查询全部
                if (newVal === "1000") {
                    this.GetQuestionInfo(this.searchKey, "")
                    return
                }
                this.GetQuestionInfo(this.searchKey, this.passClassId)
            } else if (this.currentSatus === "paper") {
                if (newVal === "1000") {
                    this.GetMedicalPaper(this.searchKey, "")
                    return
                }
                this.GetMedicalPaper(this.searchKey, this.passClassId)
            }
        },
        searchKey() {
            this.pageno = 1
            if (this.currentSatus === "topic") {
                clearTimeout(this.timer)
                this.timer = setTimeout(() => {
                    if (this.passClassId === "1000") {
                        this.GetQuestionInfo(this.searchKey, "")
                    } else {
                        this.GetQuestionInfo(this.searchKey, this.passClassId)
                    }
                }, 500)
            } else {
                clearTimeout(this.timer)
                this.timer = setTimeout(() => {
                    if (this.passClassId === "1000") {
                        this.GetMedicalPaper(this.searchKey, "")
                    } else {
                        this.GetMedicalPaper(this.searchKey, this.passClassId)
                    }
                }, 500)
            }
        }
    },
    activated() {
        window.scroll(0, 0)
        let oldType = this.routeType || "";
        let newType = this.$route.query.type;
        if (oldType !== newType) {
            this.routeType = newType
            if (newType === "paper") {
                this.getPaper()
            } else {
                this.GetQuestionInfo()
            }
        }
    },
    methods: {
        getSizeChange(val) {
            if (this.currentSatus === "topic") {
                if (this.passClassId === "1000") {
                    this.pagesize = val
                    this.pageno = 1
                    this.GetQuestionInfo(this.searchKey, "")
                } else {
                    this.pagesize = val
                    this.pageno = 1
                    this.GetQuestionInfo(this.searchKey, this.passClassId)
                }
            }
        },
        getCurrentChange(val) {
            this.pageno = val
            if (this.currentSatus === "topic") {
                if (this.passClassId === "1000") {
                    this.GetQuestionInfo(this.searchKey, "")
                } else {
                    this.GetQuestionInfo(this.searchKey, this.passClassId)
                }
            } else {
                this.getPaper()
            }
        },
        saveStatu(val) {
            let obj = {}
            obj.type = "person"
            obj.info = this.topicList
            obj.currentTopic = val
            window.localStorage.setItem("TopicInfo", JSON.stringify(obj))
            this.$router.push({
                path: "/publicMake",
                query: {
                    from: "organ"
                }
            })
        },
        goPublicTopicLibary() {
            this.$router.push({
                path: "/question/public"
            })
        },
        // 试题
        switchTopic() {
            if (!this.switchti) {
                this.searchKey = ""
            }
            this.switchti = true
            this.pageno = 1
            this.currentSatus = "topic"
            this.topiclIstShow = true
            if (this.passClassId === "1000") {
                this.GetQuestionInfo(this.searchKey, "")
            } else {
                this.GetQuestionInfo(this.searchKey, this.passClassId)
            }
        },
        // 试卷
        switchPaper() {
            if (this.switchti) {
                this.searchKey = ""
            }
            this.switchti = false
            this.pageno = 1
            this.getPaper();
        },
        getPaper() {
            this.currentSatus = "paper"
            this.topiclIstShow = false
            if (this.passClassId === "1000") {
                this.GetMedicalPaper(this.searchKey, "")
            } else {
                this.GetMedicalPaper(this.searchKey, this.passClassId)
            }
        },
        async GetQuestionInfo(key, id) {
            this.topicLoading = true
            try {
                const {
                    data
                } = await GetQuestionInfo({
                    sourceType: 2,
                    searchkey: key || "",
                    ecid: id || "",
                    pageno: this.pageno,
                    pagesize: this.pagesize
                });
                this.total = data.count
                console.log("this.total", this.total);
                let initial = (this.pageno * this.pagesize - this.pagesize) + 1
                data.data.forEach((v, i) => {
                    v.order = initial + i
                    v.SubjectName = replaceImgTag(v.SubjectName)
                })
                this.topicList = data.data
                this.topicLoading = false
            } catch (err) {
                console.log(err);
            }
        },
        async GetMedicalPaper(key, id) {
            this.paperLoading = true
            try {
                const {
                    data
                } = await GetMedicalPaper({
                    sourceType: 2,
                    searchkey: key || "",
                    ecid: id || "",
                    pageno: this.pageno,
                    pagesize: this.pagesize
                });
                if (this.currentSatus === "topic") {
                    this.type = "topic"
                } else {
                    this.type = "paper"
                }
                this.total = data.count
                let initial = (this.pageno * this.pagesize - this.pagesize) + 1
                data.data.forEach((v, i) => {
                    v.order = initial + i
                })
                this.PaperList = data.data
                if (this.currentSatus === "topic") {
                    this.PaperList.forEach((v, i) => {
                        if (v.SubjectName.includes("<")) {
                            let fristIndex = v.SubjectName.indexOf("<")
                            v.SubjectName = v.SubjectName.substring(0, fristIndex)
                        }
                    })
                }

                this.paperLoading = false
            } catch (err) {
                console.log(err);
            }
        }

    }
}

</script>

<style scoped lang="less">
.perLibary {
    width: 100%;
    margin-bottom: 30px;

    .bottom {
        box-sizing: border-box;
        margin: 0 auto;

        .nav {
            width: 100%;
            height: 62px;
            background-color: white;
            padding: 0 30px 0 0;
            margin-top: 20px;
            box-sizing: border-box;

            .nav-tive {
                font-size: 16px;
                color: #72777F;

                .topic {
                    height: 62px;
                    width: 100px;
                }

                .paper {
                    height: 62px;
                    width: 100px;
                }

                .throw {
                    margin-top: 2px;
                    width: 20px;
                    height: 4px;
                    background: #256CF4;
                    border-radius: 2px;
                }

                .avtie {
                    color: #256CF4;
                    margin-top: 4px;
                }
            }

            ::v-deep .el-input {
                .el-input__inner {
                    border-color: #4A78D4;;

                }

                .el-input-group__append {
                    background-color: #256CF4;
                    border: 2px solid #256CF4;
                    color: white;
                }
            }

        }

        .topicList {
            .loadingContent {
                width: 100%;
                height: 500px;
                background-color: white;
            }
        }

        .PaperList {
            .loadingContent {
                width: 100%;
                height: 500px;
                background-color: white;
            }
        }

    }

    .paging {
        margin-top: 30px;
        width: 100%;

        ::v-deep .el-pager {
            .number {
                background-color: #fff;
            }
        }
    }

    .selectType {
        width: 80px;
        height: 88px;
        background: #256CF4;
        box-shadow: 0px 5px 15px 0px rgba(143, 146, 154, 0.2);
        border-radius: 8px;
        position: fixed;
        right: 40px;
        bottom: 365px;

        img {
            width: 35px;
            height: 40px;
        }
    }

    .el-backtop {
        width: unset;
        right: 40px !important;
        bottom: 300px !important;

        .test {
            width: 80px;
            height: 80px;
            background: #FFFFFF;
            box-shadow: 0px 5px 15px 0px rgba(143, 146, 154, 0.2);
            border-radius: 8px;
        }
    }
}

</style>
